var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),[_c('FileDownload',{attrs:{"List":_vm.appendList,"id":_vm.id,"fieldtype":11},on:{"Delete":_vm.Delete,"uploadFile":_vm.uploadFile,"saveSuccess":function($event){{}}}})]],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-box"},[_c('div',{staticClass:"split-line"}),_c('div',{staticClass:"split-name"},[_vm._v("【竞价文件】")])])
}]

export { render, staticRenderFns }